var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChangeGoalItemGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-change-goal-item",
    d: "M12,2A10,10,0,1,0,22,12a9.773,9.773,0,0,0-.61-3.39l-1.6,1.6A7.748,7.748,0,0,1,20,12a8,8,0,1,1-8-8,7.748,7.748,0,0,1,1.79.21L15.4,2.6A10.1,10.1,0,0,0,12,2m7,0L15,6V7.5l-2.55,2.55A1.384,1.384,0,0,0,12,10a2,2,0,1,0,2,2,1.384,1.384,0,0,0-.05-.45L16.5,9H18l4-4H19V2M12,6a6,6,0,1,0,6,6H16a4,4,0,1,1-4-4Z",
    transform: "translate(-2 -2)",
    fill: "#00c2ab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangeGoalItemGreen);
export default __webpack_public_path__ + "static/media/icon-change-goal-item-green.5d4ff8f1.svg";
export { ForwardRef as ReactComponent };